import moment from "moment";
import { FC } from "react";
import { MeatCourse360Model } from "../../types";
import { CourseStatus } from "../../types/enum/course-status";

type Props = {
    course360s: MeatCourse360Model[] | undefined | null,
}

export const EnquiryMeatCourseDetails: FC<Props> = ({ course360s }) => {
    return (
        <div className="enguiry-content" style={{ paddingTop: '20px', borderTop: '1px solid #ddd', marginTop: '20px' }}>
            <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '10px', marginBottom: '5px' }}>Course Details</h4>
            <p style={{ textAlign: 'left', marginBottom: '15px', fontSize: '14px', color: '#666' }}>Your Completed Courses will be displayed here</p>
            <table id="example1" className="table table-striped table-bordered">
                <thead style={{ backgroundColor: '#f5f5f5' }}>
                    <tr>
                        <th style={{ textAlign: 'left', fontSize: '15px', verticalAlign: 'middle', fontWeight: 'bold' }}>Course Title</th>
                        <th style={{ textAlign: 'center', fontSize: '15px', verticalAlign: 'middle', fontWeight: 'bold', width: '125px' }}>Passed Date</th>
                        <th style={{ textAlign: 'center', fontSize: '15px', verticalAlign: 'middle', fontWeight: 'bold', width: '125px' }}>Validity Date</th>
                        <th style={{ textAlign: 'center', fontSize: '15px', verticalAlign: 'middle', fontWeight: 'bold', width: '100px' }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {course360s?.map(x => {
                        const isExpired = x.expiredOn && moment(x.expiredOn).isBefore(moment());
                        const effectiveStatus = isExpired ? CourseStatus.Expired : x.status;
                        const statusText = CourseStatus[effectiveStatus];
                        const isPass = effectiveStatus === CourseStatus.Pass;
                        return (
                            <tr key={x.id}>
                                <td style={{ verticalAlign: 'middle', fontSize: '15px', textAlign: 'left' }}>{x.courseText}</td>
                                <td style={{ verticalAlign: 'middle', fontSize: '15px', textAlign: 'center' }}>{x.issuedOn ? moment(x.issuedOn).format('DD/MM/YYYY') : '-'}</td>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: '15px' }}>{x.expiredOn ? moment(x.expiredOn).format('DD/MM/YYYY') : '-'}</td>
                                <td className={isPass ? 'status-active' : 'status-inactive'} style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: '15px' }}>{statusText}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}